import React from "react";
import { useSelector } from "react-redux";

import { addMobileOrLandscapeClass } from "../../lib/utils";
import GalleryNavBar from "./GalleryNavBar";
import { CloseGalleryButton } from "./CloseGalleryButton";
import { GalleryAnswers } from "./GalleryAnswers";
import { getActiveModule } from "../../store";

export const AdvancedFloorplans = ({ isMobileLandscape }) => {
  const activeModule = useSelector(getActiveModule);
  const iframeSrc = activeModule.link_href;

  return (
    <>
      <div className={addMobileOrLandscapeClass("gallery column")}>
        {!isMobileLandscape ? <GalleryNavBar /> : null}
        <div style={{ height: "80%", borderRadius: "6px", overflow: "hidden" }}>
          <iframe style={{ width: "100%", height: "100%", border: "none" }} src={iframeSrc} />
        </div>
      </div>

      <div className={addMobileOrLandscapeClass("right-column column")}>
        <GalleryAnswers />
        <CloseGalleryButton />
      </div>
    </>
  );
};
